import { render, staticRenderFns } from "./TOCXROHL.vue?vue&type=template&id=4f2dcedc&scoped=true"
import script from "./TOCXROHL.vue?vue&type=script&lang=js"
export * from "./TOCXROHL.vue?vue&type=script&lang=js"
import style0 from "./TOCXROHL.vue?vue&type=style&index=0&id=4f2dcedc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2dcedc",
  null
  
)

export default component.exports